import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const acceptOffer = {
    namespaced: true,
    state: {
        dataAcceptIsFetching: false,
        typeInfoOfferAccept: "",
        headInfoOfferAccept: "",
        isOfferAccept: false,
        textInfoOfferAccept: "",
        preparedOfferData: {},
    },
    mutations: {
        DATA_SAVE_REQUEST(state, value) {
            state.dataAcceptIsFetching = value;
        },
        DATA_SAVE_SUCCESS(state, response) {
            state.typeInfoOfferAccept = "green";
            state.headInfoOfferAccept = response.data.message;
            state.textInfoOfferAccept = response.data.data.textInfo;
            state.isOfferAccept = true;
            state.dataAcceptIsFetching = false;
            eventBus.$emit("acceptOfferSuccess", response.data);
        },
        DATA_SAVE_FAILURE(state, error) {
            state.textInfoOfferAccept = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoOfferAccept = "red";
            state.headInfoOfferAccept = error.response.data.message;
            state.isOfferAccept = true;
            state.dataAcceptIsFetching = false;
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isOfferAccept = value;
        },
        PREPARE_OFFER_DATA(state, data) {
            state.preparedOfferData = data;
        }
    },
    actions: {
        acceptOfferProjectData: function({dispatch, state}, payload) {
            state.dataAcceptIsFetching = true;
            let promise = sendRequest("put", config.baseURLApi + "/offers/accept/" + payload.creds.id, {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataAccept", result[1])
                } else {
                    dispatch("failureDataAccept", result[1]);
                }
                state.dataAcceptIsFetching = false;
            });
        },
        acceptOfferToExistingProject: function({dispatch, state}, payload) {
            state.dataAcceptIsFetching = true;
            let promise = sendRequest("put", config.baseURLApi + "/offers/accept/overwriteProject/" + payload.creds.projectId, {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataAccept", result[1])
                } else {
                    dispatch("failureDataAccept", result[1]);
                }
                state.dataAcceptIsFetching = false;
            });
        },

        requestDataAccept: function({commit}, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        successDataAccept: function({commit}, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataAccept: function({commit}, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        updateVisibleModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        },
        prepareOfferData: function({commit}, data) {
            commit("PREPARE_OFFER_DATA", data);
        }
    }
}

export default acceptOffer;